var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 4,
    fill: "#E0F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3 15.1C19.3 14.7686 19.5686 14.5 19.9 14.5H24.4C24.7314 14.5 25 14.7686 25 15.1V16.9L25.0046 16.9H28.75C29.0814 16.9 29.35 17.1686 29.35 17.5C29.35 17.8314 29.0814 18.1 28.75 18.1H28.15C28.15 18.1205 28.149 18.1412 28.1468 18.162L26.9468 29.712C26.915 30.0177 26.6574 30.25 26.35 30.25H17.8C17.4926 30.25 17.235 30.0177 17.2032 29.712L16.0032 18.162C16.001 18.1412 16 18.1205 16 18.1H15.4C15.0686 18.1 14.8 17.8314 14.8 17.5C14.8 17.1686 15.0686 16.9 15.4 16.9H19.2953C19.2969 16.9 19.2984 16.9 19.3 16.9V15.1ZM18.7381 18.1L19.3013 26.6893C19.323 27.0199 19.6086 27.2704 19.9393 27.2487C20.2699 27.227 20.5204 26.9414 20.4987 26.6107L19.9406 18.1H21.4V26.65C21.4 26.9814 21.6686 27.25 22 27.25C22.3314 27.25 22.6 26.9814 22.6 26.65V18.1H24.3593L23.8013 26.6107C23.7796 26.9414 24.0301 27.227 24.3607 27.2487C24.6914 27.2704 24.977 27.0199 24.9987 26.6893L25.5619 18.1H26.9468L25.8091 29.05H18.3409L17.2032 18.1H18.7381ZM23.8 15.7V16.9H22H20.5V15.7H23.8Z",
    fill: "url(#paint0_linear_1781_6622)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1781_6622",
    x1: 35.1473,
    y1: 13.208,
    x2: 11.6579,
    y2: 29.1783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB073"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.547c83d700898a8e5910fdc58588c03d.svg";
export { ForwardRef as ReactComponent };